export const content = {
    hero: {
        title: "The Future of Media is Fluid",
        headline: "Most Media Companies Are\nLeaving Revenue\non the Table",
        subtitle: "We turn content into measurable, scalable revenue across YouTube and AVOD\n\nRecover missed revenue. Scale what already works.\nFull transparency. Real-time insights. Complete control.",
        stats: [
            { label: "Partner Channels", value: "250+" },
            { label: "IP Portfolio", value: "16,000+" },
            { label: "Global Markets", value: "100+" },
            { label: "Growth Engine", value: "24/7" },
        ]
    },
    valueProps: [
        {
            title: "Hybrid Protection",
            description: "AI + Human Intelligence. 24/7 digital fingerprinting combined with expert manual review to capture every unauthorized upload."
        },
        {
            title: "UGC Monetization",
            description: "Turn fans into revenue. We automatically claim and monetize User-Generated Content instead of blindly blocking it."
        },
        {
            title: "YouTube & AVOD Mastery",
            description: "Maximize yield across YouTube (Content ID), Facebook, and DailyMotion with our tailored AVOD distribution engines."
        },
        {
            title: "Podkraft Audio",
            description: "Beyond video. Monetize your soundtracks and podcasts across Spotify, Apple Podcasts, and global audio networks."
        },
        {
            title: "Glocalization Studio",
            description: "Unlock 100+ languages. Premium dubbing, subtitling, and archive restoration to revitalize your TV Series globally."
        },
        {
            title: "Live Transparency",
            description: "100% Audit-Ready. A live dashboard tracking every cent, from official uploads to fan videos, in real-time."
        }
    ],
    caseStudies: [
        {
            id: 1,
            title: "Project Alpha",
            category: "TV Drama Series",
            metric: "1,700%+",
            metricLabel: "Revenue Growth",
            description: "Expanded global reach with Arabic subtitles & Spanish dubbing. Achieved 29x content consumption growth."
        },
        {
            id: 2,
            title: "Project Beta",
            category: "TV Drama Series",
            metric: "250%+",
            metricLabel: "Revenue Growth",
            description: "Localized into Urdu, Arabic & English. Unlocked new regional revenue streams beyond original market."
        },
        {
            id: 3,
            title: "Major Sports Partner",
            category: "Sports Club",
            metric: "9x",
            metricLabel: "Revenue Increase",
            description: "Eliminated copyright violations and activated new exclusive member-only content streams."
        },
        {
            id: 4,
            title: "Project Gamma",
            category: "Documentary",
            metric: "150%",
            metricLabel: "Audience Growth",
            description: "Documentary series localized for LatAm market, doubling viewership in first quarter."
        },
        {
            id: 5,
            title: "Project Delta",
            category: "Animation",
            metric: "3M+",
            metricLabel: "New Subscribers",
            description: "Kids animation channel optimized for YouTube Kids app, reaching millions of new subscribers."
        },
        {
            id: 6,
            title: "Project Epsilon",
            category: "Reality TV",
            metric: "40%",
            metricLabel: "Retention Rate",
            description: "Reality show monetization strategy overhaul, significantly improving viewer retention."
        },
        {
            id: 7,
            title: "Project Zeta",
            category: "Music Label",
            metric: "500K+",
            metricLabel: "Daily Views",
            description: "Music video distribution network optimized for MENA region, hitting half a million daily views."
        },
        {
            id: 8,
            title: "Project Eta",
            category: "News Network",
            metric: "24/7",
            metricLabel: "Live Coverage",
            description: "Implemented 24/7 live streaming infrastructure for a major news network."
        },
        {
            id: 9,
            title: "Project Theta",
            category: "TV Drama",
            metric: "10x",
            metricLabel: "Engagement",
            description: "Prime-time drama expansion into new digital platforms, increasing community engagement tenfold."
        },
        {
            id: 10,
            title: "Project Iota",
            category: "Cinema",
            metric: "85%",
            metricLabel: "Ad Revenue",
            description: "Feature film digital distribution strategy, optimizing ad placements for maximum revenue."
        },
        {
            id: 11,
            title: "Project Kappa",
            category: "Mini Series",
            metric: "1M+",
            metricLabel: "Global Reach",
            description: "Historical mini-series localization, reaching over a million viewers across 20 countries."
        },
        {
            id: 12,
            title: "Project Lambda",
            category: "TV Drama",
            metric: "200%",
            metricLabel: "ROI Increase",
            description: "TV drama rights management strategy, tripling sponsorship deals within six months."
        },
        {
            id: 13,
            title: "Project Mu",
            category: "Podcast",
            metric: "5M+",
            metricLabel: "Monthly Downloads",
            description: "Distribution strategy for a major podcast network, reaching global listeners."
        },
        {
            id: 14,
            title: "Project Nu",
            category: "Cinema",
            metric: "50+",
            metricLabel: "Localization Markets",
            description: "Content festival strategy for independent cinema projects across Europe and Asia."
        },
        {
            id: 15,
            title: "Project Xi",
            category: "TV Drama",
            metric: "300%",
            metricLabel: "Audience Lift",
            description: "TV series digital integration for a major broadcaster, driving significant viewer growth."
        },
        {
            id: 16,
            title: "Project Omicron",
            category: "Cinema",
            metric: "2M+",
            metricLabel: "Digital Reach",
            description: "Classic cinema restoration and digital release for international markets."
        },
        {
            id: 17,
            title: "Project Pi",
            category: "TV Drama",
            metric: "400%",
            metricLabel: "Social Sentiment",
            description: "Drama series fan engagement strategy on social platforms, driving massive positive sentiment."
        },
        {
            id: 18,
            title: "Project Rho",
            category: "Mini Series",
            metric: "12x",
            metricLabel: "Monetization Growth",
            description: "Historical series monetization via international distribution and sponsorship integrations."
        }
    ],
    ecosystem: {
        title: "The Live Control Dashboard",
        subtitle: "Forget spreadsheets. Track revenue, UGC claims, and global viewership across one unified, audit-ready platform.",
        hook: "YouTube is the stage. Transparency is the script. Revenue is the outcome.",
        dashboard: {
            title: "Partner Dashboard",
            features: [
                {
                    title: "Hybrid Intelligence",
                    description: "AI automation paired with 20 years of expert manual rights management to ensure zero revenue loss."
                },
                {
                    title: "UGC Claim Engine",
                    description: "Instant visibility into fan uploads being monetized and redirected as profit for your IP."
                },
                {
                    title: "Advanced Global BI",
                    description: "Track performance heatmaps by Country, Series, or Episode with real-time reporting."
                }
            ]
        },
        mobile: {
            title: "Go Nova Mobile",
            platforms: ["iOS", "Android"],
            features: ["24/7 Monitoring", "Instant Alerts", "Financial Control"],
            links: {
                ios: "https://apps.apple.com/tr/app/go-nova/id6757517931?l=tr",
                android: "https://play.google.com/store/apps/details?id=com.gonovamedia.gonova&hl=tr"
            }
        }
    }
};
